import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const segment = !IS_BIZ_USER && !IS_PAID_USER && !(IS_WEBVIEW || IS_MOBILE_BROWSER);

const multiTariffUpsaleValue = getFeature('multi-tariff-upsale');

const multiTariffUpsale: 'a' | 'b' | 'c' = multiTariffUpsaleValue || 'a';

export const enabledMultiTariffUpsaleB: boolean = multiTariffUpsale === 'b';

export const enabledMultiTariffUpsaleC: boolean = multiTariffUpsale === 'c';

export const enabledMultiTariffUpsale: boolean = segment && (enabledMultiTariffUpsaleB || enabledMultiTariffUpsaleC);

export const multiAdvancedUpsaleTariffList: string[] = getFeature('multi-advanced-upsale-tariff-list') || [
    'W256GB_1y_landing_segmentation_discount_force_trial',
    'W512GB_1y_landing_segmentation_discount_force_trial',
    'W1TB_1y_landing_segmentation_discount_force_trial',
    'W2TB_1y_landing_segmentation_discount_force_trial',
];

export const multiBasicUpsaleTariffList: string[] = getFeature('multi-basic-upsale-tariff-list') || [
    'W256GB_1y_minimal_line_with_ads_discount_force_trial',
    'W512GB_1y_minimal_line_with_ads_discount_force_trial',
    'W1TB_1y_minimal_line_with_ads_discount_force_trial',
    'W2TB_1y_minimal_line_with_ads_discount_force_trial',
];

if (segment) {
    registerExperiment(
        'upsale-multi',
        multiTariffUpsaleValue,
        [
            AnalyticEventNames.UPSALE_MULTI_MODAL_SHOW,
            AnalyticEventNames.UPSALE_MULTI_MODAL_SWITCH,
            AnalyticEventNames.UPSALE_MULTI_MODAL__CONTINUE,
            AnalyticEventNames.UPSALE_MULTI_MODAL_CLOSE,
        ],
        {
            mapEventNames: {
                UPSALE_MULTI_MODAL_SHOW: 'show',
                UPSALE_MULTI_MODAL_SWITCH: 'switch',
                UPSALE_MULTI_MODAL__CONTINUE: 'continue',
                UPSALE_MULTI_MODAL_CLOSE: 'close',
            },
        }
    );
}
